import React from 'react'
import { Icons, Illustrations } from '../../../new-components/atoms'


interface Screen3Props {
  onTrackOrder: () => void
  loading: boolean
  onClose: () => void
}

const Screen3: React.FC<Screen3Props> = ({ onTrackOrder, loading, onClose }) => {
  return (
    <div
      style={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}>
      <div
        className="header-section"
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '32px',
          backgroundColor: '#fff',
          borderBottom: '1px solid #E3E3E3',
          padding: '24px',
        }}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}>
          <div
            style={{
              width: '34px',
              height: '34px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <Icons.ShoppingBag 
              width="34"
              height="34"
              color="#6B7B3C"
            />
          </div>
          <h2
            className="header-title"
            style={{
              fontSize: '20px',
              lineHeight: '28px',
              fontWeight: '600',
              color: '#6B7B3C',
              margin: 0
            }}>
            Cannect cuida por você
          </h2>
        </div>
        <button
          onClick={onClose}
          style={{
            background: 'none',
            border: 'none',
            fontSize: '1.5rem',
            color: '#6B7B3C',
            cursor: 'pointer',
            padding: '4px',
            borderRadius: '4px',
            transition: 'color 0.2s'
          }}>
          ×
        </button>
      </div>

      <div className="content-section" style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', padding: '0 24px' }}>
        <h3
          className="success-title"
          style={{
            fontSize: '1.5rem',
            fontWeight: '700',
            color: '#374151',
            marginBottom: '232px',
            textAlign: 'center'
          }}>
          Assinatura concluída com sucesso!
        </h3>

        <div
          className="illustration-container"
          style={{
            display: 'flex',
            justifyContent: 'center',
            marginBottom: '32px'
          }}>
          <div
            className="illustration-wrapper"
            style={{
              width: '140px',
              height: '140px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              position: 'relative'
            }}>
            <div
              style={{
                fontSize: '3rem',
                transform: 'scale(0.8)',
                position: 'absolute',
                bottom: '10px'
              }}>
              <Illustrations.JourneyFinished 
                  width="320"
                  height="320"
              />
            </div>

            <div
              style={{
                position: 'absolute',
                top: '10px',
                right: '10px',
                width: '40px',
                height: '40px',
                backgroundColor: '#10b981',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '1.5rem',
                color: 'white',
                fontWeight: 'bold'
              }}>
              ✓
            </div>
          </div>
        </div>

        <p
          className="description-text"
          style={{
            color: '#6b7280',
            fontSize: '1rem',
            lineHeight: '1.6',
            textAlign: 'center',
            marginBottom: '32px'
          }}>
          Sua procuração foi assinada digitalmente e está pronta para ser baixada. A CANNECT agora pode solicitar sua
          autorização de importação junto à ANVISA.
        </p>
      </div>

      <div 
      className="button-section"
      style={{ padding: '0 24px 44px 24px' }}  >
      <button
        onClick={onTrackOrder}
        disabled={loading}
        style={{
          width: '100%',
          background: loading ? '#9ca3af' : '#748351',
          color: 'white',
          border: 'none',
          borderRadius: '8px',
          padding: '16px 24px',
          fontSize: '1rem',
          fontWeight: '600',
          cursor: loading ? 'not-allowed' : 'pointer',
          transition: 'background-color 0.2s',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '8px'
        }}>
        {loading ? (
          <>
            <div
              style={{
                width: '16px',
                height: '16px',
                border: '2px solid transparent',
                borderTop: '2px solid white',
                borderRadius: '50%',
                animation: 'spin 1s linear infinite'
              }}
            />
            carregando...
          </>
        ) : (
          <>
            Acompanhar pedido
          </>
        )}
      </button>
      </div>
      <style>{`
        @keyframes spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }

        /* Estilos para desktop - garantir espaçamentos adequados */
        @media (min-width: 769px) {
          .header-section {
            padding: 24px !important;
            margin-bottom: 32px !important;
          }
          
          .content-section {
            padding: 0 24px !important;
          }
          
          .success-title {
            font-size: 1.5rem !important;
            margin-bottom: 232px !important;
          }
          
          .illustration-container {
            margin-bottom: 32px !important;
          }
          
          .illustration-wrapper {
            width: 140px !important;
            height: 140px !important;
          }
          
          .description-text {
            font-size: 1rem !important;
            margin-bottom: 32px !important;
          }
          
          .button-section {
            padding: 0 24px 44px 24px !important;
          }
        }

        @media (max-width: 768px) {
          .header-section {
            padding: 16px !important;
            margin-bottom: 24px !important;
          }
          
          .header-title {
            font-size: 18px !important;
            line-height: 24px !important;
          }
          
          .content-section {
            padding: 0 16px !important;
          }
          
          .success-title {
            font-size: 1.3rem !important;
            margin-bottom: 120px !important;
          }
          
          .illustration-container {
            margin-bottom: 24px !important;
          }
          
          .illustration-wrapper {
            width: 120px !important;
            height: 120px !important;
          }
          
          .description-text {
            font-size: 0.9rem !important;
            margin-bottom: 32px !important;
          }
          
          .button-section {
            padding: 0 16px 32px 16px !important;
          }
        }
        
        @media (max-width: 480px) {
          .header-section {
            padding: 12px !important;
            margin-bottom: 20px !important;
          }
          
          .header-title {
            font-size: 16px !important;
            line-height: 22px !important;
          }
          
          .content-section {
            padding: 0 12px !important;
          }
          
          .success-title {
            font-size: 1.2rem !important;
            margin-bottom: 80px !important;
          }
          
          .illustration-container {
            margin-bottom: 20px !important;
          }
          
          .illustration-wrapper {
            width: 100px !important;
            height: 100px !important;
          }
          
          .description-text {
            font-size: 0.85rem !important;
            margin-bottom: 28px !important;
          }
          
          .button-section {
            padding: 0 12px 24px 12px !important;
          }
        }
      `}</style>
    </div>
  )
}

export default Screen3
